export default "__VITE_ASSET__7270ea27__"